export const siteUrl = "https://imanaclub.fr";

export const seoFaqs = [
  {
    question: "Peut-on commencer le MMA ou le JJB sans expérience ?",
    answer:
      "Oui. Les cours d’Imana Academy accueillent les débutants comme les pratiquants confirmés. Le coach adapte les consignes au niveau de chacun.",
  },
  {
    question: "À partir de quel âge les enfants peuvent-ils s’inscrire ?",
    answer:
      "Les cours enfants sont accessibles à partir de 6 ans et demi. L’équipe oriente ensuite chaque enfant vers le groupe adapté à son âge.",
  },
  {
    question: "Où ont lieu les entraînements ?",
    answer:
      "Les cours ont lieu à Savigny-le-Temple 77176, au gymnase Jean Zay et au gymnase Léo Lagrange. Le lieu exact est indiqué pour chaque créneau dans le planning.",
  },
  {
    question: "Quelle tenue faut-il prévoir pour un premier cours ?",
    answer:
      "Pour le Jiu-Jitsu Brésilien, le kimono est obligatoire. Pour le MMA et le grappling, prévois un short avec un t-shirt ou un rashguard.",
  },
  {
    question: "Quelle est la différence entre le MMA et le Jiu-Jitsu Brésilien ?",
    answer:
      "Le MMA associe percussion, lutte et combat au sol. Le Jiu-Jitsu Brésilien se concentre sur les positions, les contrôles et les soumissions au sol.",
  },
  {
    question: "Comment réserver un cours d’essai ?",
    answer:
      "Le premier cours est offert. Remplis le formulaire d’inscription en ligne ou contacte directement l’équipe, puis choisis un créneau dans le planning du club.",
  },
] as const;
